import { ReactElement, use } from 'react';
import { FormProvider } from 'react-hook-form';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import IconButton from '@mui/material/IconButton';

import WanderingBoundaryPassageRowProviderContext from 'features/wandering-boundary-settings/providers/contexts/wandering-boundary-passage-row-provider-context';
import BlockingPassageWarning from 'features/wandering-boundary-settings/views/wandering-boundary-passage-row/components/blocking-passage-warning';
import DetectionLoopSelect from 'features/wandering-boundary-settings/views/wandering-boundary-passage-row/components/detection-loop-select';
import DomipSelect from 'features/wandering-boundary-settings/views/wandering-boundary-passage-row/components/domip-select';
import NameInputField from 'features/wandering-boundary-settings/views/wandering-boundary-passage-row/components/name-input-field';
import WanderingBoundarySelect from 'features/wandering-boundary-settings/views/wandering-boundary-passage-row/components/wandering-boundary-select';
import styles from './wandering-boundary-passage-row-create-edit.module.scss';

const WanderingBoundaryPassageRowCreateEdit = (): ReactElement => {
  const { wanderingBoundaryPassage, form, submitForm, cancelCreateWanderingBoundaryPassage, stopEditing, viewingMode } = use(
    WanderingBoundaryPassageRowProviderContext,
  );

  const isEditing = viewingMode === 'editing';

  return (
    <div className={styles.wanderingBoundaryPassageRowContainer}>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(submitForm)}>
          <div className={styles.inputFields}>
            <NameInputField />
            <div className={styles.selectRow}>
              <WanderingBoundarySelect fieldName="wanderingBoundaryAId" />
              <WanderingBoundarySelect fieldName="wanderingBoundaryBId" />
            </div>
            <div className={styles.selectRow}>
              <DetectionLoopSelect fieldName="detectionLoopADeviceId" />
              <DetectionLoopSelect fieldName="detectionLoopBDeviceId" />
            </div>
            <div className={styles.selectRow}>
              <DomipSelect fieldName="domipADeviceId" />
              <DomipSelect fieldName="domipBDeviceId" />
            </div>
            <div className={styles.selectRow}>
              <BlockingPassageWarning fieldName="blockingPassageWarningTimeAInMinutes" />
              <BlockingPassageWarning fieldName="blockingPassageWarningTimeBInMinutes" />
            </div>
          </div>
          <div className={styles.buttonsContainer}>
            <IconButton
              className={styles.cancelButton}
              onClick={() => (isEditing ? stopEditing() : cancelCreateWanderingBoundaryPassage(wanderingBoundaryPassage))}
            >
              <CloseRoundedIcon />
            </IconButton>
            <IconButton className={styles.checkButton} type="submit">
              <CheckRoundedIcon />
            </IconButton>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default WanderingBoundaryPassageRowCreateEdit;
